// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1763":"002d7a8f","7481":"7c234f77","7768":"a7e027fb","7866":"a7e027fb","8706":"c2047194","9924":"f91879d3"}[chunkId] + ".chunk.css";
};